export const ATTENDANCE_CONSTANTS = {
  STUDENT: "student",
  PARENT: "parent",
  FAMILY: "family",
  STAFF: "staff",
  TEACHER_PORTAL: "TEACHER_PORTAL",
  YYYY_MM_DD: "YYYY-MM-DD",
  EXCUSAL_DATE_FORMAT: "D MMM YY",
  CREATE: "CREATE",
  EDIT: "EDIT",
  NEW_ATTENDANCE_EXCUSAL_RECEIVED: "NEW_ATTENDANCE_EXCUSAL_RECEIVED",
  ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED: "ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED",
  FAMILY_MEMBER: "FAMILY_MEMBER",
  ATTENDANCE_MARKED: "ATTENDANCE_MARKED",
  ATTENDANCE_MARKED_ON_EXCUSAL: "ATTENDANCE_MARKED_ON_EXCUSAL",
  ATTENDANCE_REMINDER_TO_HOMEROOM: "ATTENDANCE_REMINDER_TO_HOMEROOM",
  NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_HOMEROOM:
    "NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_HOMEROOM",
  ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED_TO_HOMEROOM:
    "ATTENDANCE_EXCUSAL_MESSAGE_RECEIVED_TO_HOMEROOM",
  ATTENDANCE_MARKED_ON_EXCUSAL_TO_HOMEROOM:
    "ATTENDANCE_MARKED_ON_EXCUSAL_TO_HOMEROOM",
  SCROLL: "scroll",
  NAME: "NAME",
  SOURCED_ID: "SOURCED_ID",
  ACTIVE: "ACTIVE",
  DELETE: "DELETE",
  STUDENT_ATTENDANCE: "STUDENT_ATTENDANCE",
  ATTENDANCE_CATEGORY: "ATTENDANCE_CATEGORY",
  ATTENDANCE_CLASSES: "ATTENDANCE_CLASSES",
  ALL: "all",
  ATTENDANCE_DATA_TYPE: "ATTENDANCE_DATA_TYPE",
  PERCENTAGE: "PERCENTAGE",
  NUMBERS: "NUMBERS",
  STUDENTS_ATTENDANCE_SUMMARY_DATA_TYPE: "StudentsAttendanceSummaryDataType",
  TABLE_ROWS: "TableRows",
  TABLE_COLUMNS: "TableColumns",
  ATTENDANCE: "attendance",
  TITLE: "TITLE",
  VALUE: "VALUE",
  ABBREVIATION: "ABBREVIATION",
  COLOR: "COLOR",
  SMS: "SMS",
  EMAIL: "EMAIL",
  ACTIONS: "ACTIONS",
  TOTAL: "TOTAL",
  PRESENCE: "PRESENCE",
  ABSENCE: "ABSENCE",
  USER: "user",
  FAMILY_MEMBER_NAME: "FAMILY_NAME",
  NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_PARENT:
    "NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_PARENT",
  NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_ADMIN:
    "NEW_ATTENDANCE_EXCUSAL_RECEIVED_TO_ADMIN",
  APPICABLE_TO: "APPICABLE_TO",
  ROTATION_CYCLE: "ROTATION_CYCLE",
  FAMILY_EMAIL: "FAMILY_EMAIL",
  ATTENDANCE_CODE: "ATTENDANCE_CODE",
  SCHOOL_NAME: "SCHOOL_NAME",
  LINK_PERIOD: "LINK_PERIOD",
  DAILY_ATTENDANCE_RECORDED_IN: "DAILY_ATTENDANCE_RECORDED_IN",
  EACH_PERIOD_WITH_ONCE_A_DAY: "EACH_PERIOD_WITH_ONCE_A_DAY",
  EACH_PERIOD: "EACH_PERIOD",
  ONCE_A_DAY: "ONCE_A_DAY",
  TIER_SET_NAME: "TIER_SET_NAME",
  DESCRIPTION: "DESCRIPTION",
  TIERS: "TIERS",
  CREATED_BY: "CREATED_BY",
  LAST_UPDATED_BY: "LAST_UPDATED_BY",
  LAST_UPDATE_AT: "LAST_UPDATE_AT",
  TIER_SET_ID: "TIER_SET_ID",
  ATTENDANCE_TIERS: "ATTENDANCE_TIERS",
  // Abbreviation size limits
  ATTENDANCE_CODE_ABBR_MAX_LENGTH: 3,
  LOCATION_ABBR_MAX_LENGTH: 4,
};

export const ROUTE_CONSTANTS = {
  REPLACE: "replace",
  PLATEFORM: "platform",
};

// need to remove this

export const TIMETABLE_CONSTANTS = {
  PERIODS: "PERIODS",
  BELL_SCHEDULES: "BELL_SCHEDULES",
  PERIOD_NAME: "PERIOD_NAME",
  ABBREVIATION: "ABBREVIATION",
  TYPE: "TYPE",
  USED_IN_BELL_SCHEDULES: "USED_IN_BELL_SCHEDULES",
  APPLIED_TO_SCHOOLS: "APPLIED_TO_SCHOOLS",
  PERIOD_ID: "PERIOD_ID",
  USED_IN_TEMPLATE: "USED_IN_TEMPLATE",
  CREATED_BY: "CREATED_BY",
  ACTIONS: "ACTIONS",
  BELL_SCHEDULE_NAME: "BELL_SCHEDULE_NAME",
  BELL_SCHEDULE_ID: "BELL_SCHEDULE_ID",
  NO_OF_PERIODS: "NO_OF_PERIODS",
  USED_IN_TEMPLATES: "USED_IN_TEMPLATES",
  SCHOOL_NAME: "SCHOOL_NAME",
  TIMETABLE_TEMPLATES: "TIMETABLE_TEMPLATES",
  DAY_CYCLES: "DAY_CYCLES",
  LAST_UPDATED_BY: "LAST_UPDATED_BY",
  TIMETABLE_NAME: "TIMETABLE_NAME",
  VALIDITY_PERIOD: "VALIDITY_PERIOD",
  APPLICABLE: "APPLICABLE",
  STATUS: "STATUS",
  TIMETABLE_ID: "TIMETABLE_ID",
  GRADES: "GRADES",
  CREATE_TIMETABLE: "CREATE_TIMETABLE",
  MODIFY_TIMETABLE: "MODIFY_TIMETABLE",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  IMPORTED_ON: "IMPORTED_ON",
  IMPORTED_BY: "IMPORTED_BY",
  IMPORTED_METHOD: "IMPORTED_METHOD",
  IMPORTED_IN_TIMETABLE: "IMPORTED_IN_TIMETABLE",
  IMPORTED_DURATION: "IMPORTED_DURATION",
};
